import { QRCode } from '@/components/qr/QRCode';
import { useSearchParams } from 'react-router-dom';

/**
 * Full-screen, scannable/printable QR "poster" — a single page on a primary
 * background with a large white, rounded QR. Opened in its own window/tab from
 * the access-code displays (`/qr?value=CODE&label=...`) so an admin can show it
 * on a phone for teams to scan, or print it for the challenge location.
 */
export function QrPosterPage() {
  const [params] = useSearchParams();
  const value = params.get('value') ?? '';
  const label = params.get('label') ?? '';

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-8 bg-primary p-6">
      {value ? (
        <>
          <QRCode
            value={value}
            size={1024}
            alt={`QR code for ${value}`}
            className="!rounded-[2rem] !p-6 shadow-2xl w-[min(80vmin,560px)] h-[min(80vmin,560px)]"
          />
          <div className="text-center">
            {label && (
              <p className="text-2xl font-semibold text-primary-foreground">{label}</p>
            )}
            <p className="mt-1 font-mono text-2xl tracking-[0.35em] text-primary-foreground/85">
              {value}
            </p>
          </div>
        </>
      ) : (
        <p className="text-primary-foreground">No code to display.</p>
      )}
    </div>
  );
}
